import { library } from "@fortawesome/fontawesome-svg-core";
import * as fasIcons from "@fortawesome/free-solid-svg-icons";
import * as fabIcons from "@fortawesome/free-brands-svg-icons";

const fasIconObjects = Object.keys(fasIcons).filter(
  (key) => key !== "fas" && key !== "prefix"
);

const fabIconObjects = Object.keys(fabIcons).filter(
  (key) => key !== "fab" && key !== "prefix"
);

export const fasIconsNames = fasIconObjects
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  .map((icon) => fasIcons[icon].iconName);
export const fabIconsNames = fabIconObjects
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  .map((icon) => fabIcons[icon].iconName);

const iconList = fasIconObjects
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  .map((icon) => fasIcons[icon])
  .concat(
    fabIconObjects
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      .map((icon) => fabIcons[icon])
  );

library.add(...iconList);
